(() => {
  // 'use strict';

  // Configuration
  const CONFIG = {
    memorySizes: ['64GB', '128GB', '256GB', '512GB', '1TB', '2TB'],
    searchLimit: 50,
    debug: true // Enable debug logging
  };

  // Initialize once
  window.Xpansion = window.Xpansion || {};
  if (window.Xpansion.phoneSelectorReady) return;
  window.Xpansion.phoneSelectorReady = true;

  // Check if phone selector is enabled on this page
  const container = document.querySelector('.phone-selector-enabled');
  if (!container) return;

  /**
   * Parse product title into components
   * Example: "iPhone 15 Pro 256GB Zwart" -> {model: "iPhone 15 Pro", memory: "256GB", color: "Zwart"}
   */
  function parseProductTitle(title) {
    const parts = title.trim().split(/\s+/);
    let memory = null;
    let color = null;
    const modelParts = [];

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      
      if (CONFIG.memorySizes.some(size => part.toUpperCase().includes(size.toUpperCase()))) {
        memory = part;
        if (i + 1 < parts.length) {
          color = parts.slice(i + 1).join(' ');
        }
        break;
      }
      
      modelParts.push(part);
    }

    return {
      model: modelParts.join(' '),
      memory: memory,
      color: color
    };
  }

  /**
   * Get product title from page
   */
  function getProductTitle() {
    const titleElement = document.querySelector('.product-title, [data-product-title], h1, .f8pr h1');
    return titleElement ? titleElement.textContent.trim() : null;
  }

  /**
   * Get collection handle from product model name
   * Converts model name to collection handle format (lowercase, spaces to hyphens)
   * Example: "iPhone 15 Pro" -> "iphone-15-pro"
   */
  function getCollectionHandle(modelName) {
    if (!modelName) return null;
    
    const handle = modelName.toLowerCase().replace(/\s+/g, '-');
    
    if (CONFIG.debug) {
      console.log('📂 Collection handle from model:', handle);
    }
    
    return handle;
  }

  /**
   * Fetch all products from a collection
   * Uses the collection's products.json endpoint with pagination
   */
  async function fetchCollectionProducts(collectionHandle) {
    const allProducts = [];
    let page = 1;
    const limit = 50; // Max per page
    
    if (CONFIG.debug) {
      console.log('🔍 Fetching products from collection:', collectionHandle);
    }

    try {
      while (true) {
        const url = `${window.Shopify.routes.root}collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`;
        
        if (CONFIG.debug) {
          console.log(`📄 Fetching page ${page}:`, url);
        }

        const response = await fetch(url);
        if (!response.ok) {
          const errorText = await response.text();
          if (CONFIG.debug) {
            console.error('❌ API error:', response.status, errorText);
          }
          break;
        }
        
        const data = await response.json();
        const products = data.products || [];
        
        if (CONFIG.debug) {
          console.log(`📦 Page ${page} returned:`, products.length, 'products');
        }

        if (products.length === 0) break;
        
        allProducts.push(...products);
        
        // If we got less than the limit, we've reached the end
        if (products.length < limit) break;
        
        page++;
      }

      if (CONFIG.debug) {
        console.log('✅ Total products fetched:', allProducts.length);
        console.log('📦 ALL PRODUCTS DATA:', allProducts);
        
        console.log('\n📋 Product Details:');
        allProducts.forEach((product, index) => {
          console.log(product.title, product);
          const hasAvailableVariant = Array.isArray(product.variants) &&
          product.variants.some(v => v.available === true);
        console.log(`\n${index + 1}. ${product.title}`, {
            id: product.id,
            handle: product.handle,
            available: hasAvailableVariant,
            variants: product.variants,
            tags: product.tags,
            images: product.images?.length || 0,
            product_type: product.product_type,
            vendor: product.vendor,
            full_data: product
          });
        });
      }

      const mappedProducts = allProducts.map(product => {
        const hasAvailableVariant = Array.isArray(product.variants) &&
          product.variants.some(variant => variant.available === true);
        return {
          id: product.id,
          title: product.title,
          handle: product.handle,
          url: `${window.Shopify.routes.root}products/${product.handle}`,
          available: hasAvailableVariant,
          tags: product.tags || []
        };
      });

      if (CONFIG.debug) {
        console.log('\n📤 Mapped products:', mappedProducts);
      }

      return mappedProducts;
    } catch (error) {
      console.error('❌ Phone Selector: Failed to fetch collection products', error);
      return [];
    }
  }

  /**
   * Organize products by color and memory
   */
  function organizeVariants(products) {
    const variants = {
      colors: new Map(),
      memories: new Map()
    };

    if (CONFIG.debug) {
      console.log('\n📊 Organizing', products.length, 'products');
      console.log('📦 Products to organize:', products);
    }

    products.forEach((product, index) => {
      const parsed = parseProductTitle(product.title);
      
      if (CONFIG.debug) {
        console.log(`\n${index + 1}. "${product.title}"`);
        console.log(`   Parsed → Model: "${parsed.model}", Memory: "${parsed.memory}", Color: "${parsed.color}"`);
        console.log(`   Product data:`, product);
      }

      if (!parsed.color || !parsed.memory) {
        if (CONFIG.debug) {
          console.log('    ❌ Skipped (missing color or memory)');
        }
        return;
      }

      const colorKey = parsed.color.toLowerCase().replace(/\s+/g, '-');
      const memoryKey = parsed.memory.toUpperCase();

      // Store by color
      if (!variants.colors.has(colorKey)) {
        variants.colors.set(colorKey, {
          name: parsed.color,
          products: []
        });
      }
      variants.colors.get(colorKey).products.push({
        memory: memoryKey,
        url: product.url,
        id: product.id,
        available: product.available
      });

      // Store by memory
      if (!variants.memories.has(memoryKey)) {
        variants.memories.set(memoryKey, { products: [] });
      }
      variants.memories.get(memoryKey).products.push({
        color: colorKey,
        colorName: parsed.color,
        url: product.url,
        id: product.id,
        available: product.available
      });
    });

    if (CONFIG.debug) {
      console.log('\n📊 Organization Results:');
      console.log('  Colors found:', Array.from(variants.colors.keys()));
      console.log('  Memories found:', Array.from(variants.memories.keys()));
      
      console.log('\n🎨 Colors Map (detailed):');
      variants.colors.forEach((colorData, colorKey) => {
        console.log(`  ${colorKey}:`, {
          name: colorData.name,
          products: colorData.products
        });
      });
      
      console.log('\n💾 Memories Map (detailed):');
      variants.memories.forEach((memoryData, memoryKey) => {
        console.log(`  ${memoryKey}:`, {
          products: memoryData.products
        });
      });
      
      console.log('\n📦 Full variants object:', variants);
    }

    return variants;
  }

  /**
   * Add number to custom product fields label
   */
  function addNumberToCustomFields() {
    const customFields = document.querySelector('.syncer-custom-product-fields');
    if (!customFields) return;

    const labels = customFields.querySelectorAll('.form-group > label');
    
    labels.forEach((label) => {
      if (label.querySelector('.phone-selector-wrapper-number')) return;

      const numberSpan = document.createElement('span');
      numberSpan.className = 'phone-selector-wrapper-number';
      numberSpan.textContent = '4';
      
      label.insertBefore(numberSpan, label.firstChild);
    });
  }

  /**
   * Render color options
   */
  function renderColors(colorsMap, currentProduct) {
    const wrapper = document.querySelector('.color-wrapper');
    if (!wrapper) return;

    wrapper.innerHTML = '';
    const currentColorKey = currentProduct.color.toLowerCase().replace(/\s+/g, '-');

    colorsMap.forEach((colorData, colorKey) => {
      const isActive = colorKey === currentColorKey;
      const colorClass = colorKey.replace(/\s+/g, '-');
      const isAvailable = colorData.products.some(
        p => p.memory === currentProduct.memory.toUpperCase() && p.available
      );

      const option = document.createElement('div');
      option.className = `option ${colorClass}${isActive ? ' active' : ''}`;
      option.dataset.title = colorData.name;
      option.dataset.color = colorKey;

      if (!isAvailable) {
        option.style.opacity = '0.5';
      }

      option.innerHTML = `
        <span class="${colorClass} color">${isActive ? '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.7808 4.21934C17.9212 4.35996 18.0001 4.55059 18.0001 4.74934C18.0001 4.94809 17.9212 5.13871 17.7808 5.27934L10.5308 12.5293C10.3902 12.6697 10.1996 12.7486 10.0008 12.7486C9.80208 12.7486 9.61145 12.6697 9.47083 12.5293L6.22083 9.27934C6.08835 9.13716 6.01623 8.94912 6.01965 8.75481C6.02308 8.56051 6.10179 8.37513 6.23921 8.23771C6.37662 8.1003 6.56201 8.02159 6.75631 8.01816C6.95061 8.01473 7.13865 8.08686 7.28083 8.21934L10.0008 10.9393L16.7208 4.21934C16.8614 4.07889 17.052 4 17.2508 4C17.4495 4 17.6402 4.07889 17.7808 4.21934Z" fill="white"/></svg>' : ''}</span>
        <span class="color-title${isActive ? ' show' : ''}">${colorData.name}</span>
      `;

      wrapper.appendChild(option);
    });
  }

  /**
   * Render memory options
   */
  function renderMemories(memoriesMap, currentProduct) {
    const wrapper = document.querySelector('.memory-wrapper');
    if (!wrapper) return;

    wrapper.innerHTML = '';
    const currentMemoryKey = currentProduct.memory.toUpperCase();
    const currentColorKey = currentProduct.color.toLowerCase().replace(/\s+/g, '-');

    // Sort by size
    const sortedMemories = Array.from(memoriesMap.keys()).sort((a, b) => {
      return parseInt(a) - parseInt(b);
    });

    sortedMemories.forEach((memoryKey) => {
      const memoryData = memoriesMap.get(memoryKey);
      const isActive = memoryKey === currentMemoryKey;
      const memoryClass = memoryKey.toLowerCase().replace(/gb|tb/gi, '');
      const isAvailable = memoryData.products.some(
        p => p.color === currentColorKey && p.available
      );

      const option = document.createElement('div');
      option.className = `option ${memoryClass}${isActive ? ' active' : ''}`;
      option.dataset.title = memoryKey;
      option.dataset.memory = memoryKey;

      if (!isAvailable) {
        option.style.opacity = '0.5';
      }

      option.innerHTML = `<span class="inner${isActive ? ' active' : ''}">${memoryKey}</span>`;
      wrapper.appendChild(option);
    });
  }

  /**
   * Setup click handlers for navigation
   */
  function setupClickHandlers(variants, currentProduct) {
    const colorWrapper = document.querySelector('.color-wrapper');
    const memoryWrapper = document.querySelector('.memory-wrapper');

    if (!colorWrapper || !memoryWrapper) return;

    // Color selection
    colorWrapper.addEventListener('click', (e) => {
      const option = e.target.closest('.option');
      if (!option) return;

      const selectedColor = option.dataset.color;
      const currentMemory = currentProduct.memory.toUpperCase();
      const colorData = variants.colors.get(selectedColor);

      if (colorData) {
        const matchingProduct = colorData.products.find(p => p.memory === currentMemory);
        if (matchingProduct?.url) {
          window.location.href = matchingProduct.url;
        }
      }
    });

    // Memory selection
    memoryWrapper.addEventListener('click', (e) => {
      const option = e.target.closest('.option');
      if (!option) return;

      const selectedMemory = option.dataset.memory;
      const currentColorKey = currentProduct.color.toLowerCase().replace(/\s+/g, '-');
      const memoryData = variants.memories.get(selectedMemory);

      if (memoryData) {
        const matchingProduct = memoryData.products.find(p => p.color === currentColorKey);
        if (matchingProduct?.url) {
          window.location.href = matchingProduct.url;
        }
      }
    });
  }

  /**
   * Main initialization
   */
  async function init() {
    if (CONFIG.debug) {
      console.log('\n═══════════════════════════════════════════════════');
      console.log('🚀 Phone Selector initializing...');
      console.log('═══════════════════════════════════════════════════\n');
    }

    const productTitle = getProductTitle();
    if (!productTitle) {
      if (CONFIG.debug) {
        console.log('❌ No product title found, exiting');
      }
      return;
    }

    if (CONFIG.debug) {
      console.log('📱 Product title:', productTitle);
    }

    const currentProduct = parseProductTitle(productTitle);
    if (!currentProduct.memory || !currentProduct.color || !currentProduct.model) {
      if (CONFIG.debug) {
        console.log('❌ Could not parse model/memory/color from title, exiting');
      }
      return;
    }

    if (CONFIG.debug) {
      console.log('✅ Current product:', currentProduct);
    }

    // Generate collection handle from model name
    const collectionHandle = getCollectionHandle(currentProduct.model);
    if (!collectionHandle) {
      if (CONFIG.debug) {
        console.log('❌ Could not generate collection handle, exiting');
      }
      return;
    }

    addNumberToCustomFields();

    const products = await fetchCollectionProducts(collectionHandle);
    if (products.length === 0) {
      if (CONFIG.debug) {
        console.log('❌ No products found in collection, exiting');
      }
      return;
    }

    const variants = organizeVariants(products);

    if (CONFIG.debug) {
      console.log('\n🎯 Ready to render:');
      console.log('  Current product:', currentProduct);
      console.log('  Available colors:', variants.colors.size);
      console.log('  Available memories:', variants.memories.size);
      console.log('  Variants object:', variants);
    }

    renderColors(variants.colors, currentProduct);
    renderMemories(variants.memories, currentProduct);
    setupClickHandlers(variants, currentProduct);

    if (CONFIG.debug) {
      console.log('\n✅ Phone Selector initialized successfully!');
      console.log('═══════════════════════════════════════════════════\n');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
